import { useCssBreakpoints } from "react-use-css-breakpoints";

export function useMobile() {
  const breakpoint = useCssBreakpoints();
  return breakpoint === "sm" || breakpoint === "md";
}
